module.exports = __webpack_public_path__ + "assets/img/144.cb1bc67c.png";